// تابع برای بررسی تلاش‌های ورود مشکوک
export const checkSuspiciousActivity = () => {
  const loginAttempts = JSON.parse(localStorage.getItem('loginAttempts') || '[]');
  const now = Date.now();
  const fiveMinutesAgo = now - (5 * 60 * 1000);
  
  // حذف تلاش‌های قدیمی
  const recentAttempts = loginAttempts.filter(attempt => attempt.timestamp > fiveMinutesAgo);
  
  // بررسی تعداد تلاش‌ها در 5 دقیقه گذشته
  if (recentAttempts.length >= 5) {
    return {
      isSuspicious: true,
      message: 'تعداد تلاش‌های ورود بیش از حد مجاز است. لطفاً 5 دقیقه صبر کنید.',
      remainingTime: Math.ceil((recentAttempts[0].timestamp + (5 * 60 * 1000) - now) / 1000 / 60)
    };
  }
  
  return { isSuspicious: false };
};

// تابع برای ثبت تلاش ورود
export const recordLoginAttempt = (success = false) => {
  const loginAttempts = JSON.parse(localStorage.getItem('loginAttempts') || '[]');
  const now = Date.now();
  
  loginAttempts.push({
    timestamp: now,
    success,
    ip: 'client-side' // در سمت کلاینت نمی‌توانیم IP واقعی بگیریم
  });
  
  // نگه داشتن فقط 10 تلاش آخر
  if (loginAttempts.length > 10) {
    loginAttempts.splice(0, loginAttempts.length - 10);
  }
  
  localStorage.setItem('loginAttempts', JSON.stringify(loginAttempts));
};

// تابع برای پاک کردن سابقه تلاش‌ها
export const clearLoginAttempts = () => {
  localStorage.removeItem('loginAttempts');
};

// تابع برای بررسی امنیت توکن
export const validateTokenFormat = (token) => {
  if (!token || typeof token !== 'string') {
    return false;
  }
  
  // بررسی فرمت JWT (سه بخش جدا شده با نقطه)
  const parts = token.split('.');
  if (parts.length !== 3) {
    return false;
  }
  
  // بررسی طول معقول
  if (token.length < 100 || token.length > 2000) {
    return false;
  }
  
  return true;
};

// تابع برای بررسی امنیت اطلاعات کاربر
export const validateUserData = (userData) => {
  if (!userData || typeof userData !== 'object') {
    return false;
  }
  
  // بررسی فیلدهای ضروری
  const requiredFields = ['id', 'role', 'firstName', 'lastName'];
  for (const field of requiredFields) {
    if (!userData[field]) {
      return false;
    }
  }
  
  // بررسی نقش معتبر
  const validRoles = ['user', 'business', 'admin', 'trader', 'flasher_staff'];
  if (!validRoles.includes(userData.role)) {
    return false;
  }
  
  return true;
};

// تابع برای رمزگذاری ساده اطلاعات حساس (فقط برای نمایش)
export const maskSensitiveData = (data, type = 'phone') => {
  if (!data) return '';
  
  switch (type) {
    case 'phone':
      if (data.length >= 4) {
        return data.slice(0, 2) + '*'.repeat(data.length - 4) + data.slice(-2);
      }
      return data;
    case 'email':
      const [username, domain] = data.split('@');
      if (username && domain) {
        const maskedUsername = username.slice(0, 2) + '*'.repeat(username.length - 2);
        return `${maskedUsername}@${domain}`;
      }
      return data;
    default:
      return data;
  }
};

// تابع برای بررسی امنیت localStorage
export const checkLocalStorageSecurity = () => {
  try {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && !validateTokenFormat(token)) {
      return { secure: false, message: 'توکن نامعتبر است' };
    }
    
    if (user) {
      try {
        const userData = JSON.parse(user);
        if (!validateUserData(userData)) {
          return { secure: false, message: 'اطلاعات کاربر نامعتبر است' };
        }
      } catch (error) {
        return { secure: false, message: 'خطا در پردازش اطلاعات کاربر' };
      }
    }
    
    return { secure: true };
  } catch (error) {
    return { secure: false, message: 'خطا در بررسی امنیت' };
  }
}; 